export default {
  name: 'adminJoin',
  component: () => 
    import(
      /* webpackChunkName: "adminJoinLayout" */ "@/modules/adminJoin/layouts/adminJoinLayout.vue"
    ),
  redirect: "/admin-join/menu",
  children: [
    {
      path: "cuentas",
      name: "cuentas",
      component: () =>
        import(
          /* webpackChunkName: "cuentas" */ "@/modules/adminJoin/pages/Cuentas.vue"
        ),
    },
    {
      path: "menu",
      name: "menu",
      component: () =>
        import(
          /* webpackChunkName: "menu" */ "@/modules/adminJoin/pages/Menu.vue"
        ),
    },
    {
      path: "grupos",
      name: "grupos",
      component: () =>
        import(
          /* webpackChunkName: "grupos" */ "@/modules/adminJoin/pages/Grupos.vue"
        ),
    },
    {
      path: "opciones-desconexion",
      name: "opciones-desconexion",
      component: () =>
        import(
          /* webpackChunkName: "OpcionesDesconexion" */ "@/modules/adminJoin/pages/OpcionesDesconexion.vue"
        ),
    },
    {
      path: "opciones-cierre",
      name: "opciones-cierre",
      component: () =>
        import(
          /* webpackChunkName: "OpcionesCierres" */ "@/modules/adminJoin/pages/OpcionesCierre.vue"
        ),
    },
    {
      path: "etiquetas",
      name: "etiquetas",
      component: () =>
        import(
          /* webpackChunkName: "etiquetas" */ "@/modules/adminJoin/pages/Etiquetas.vue"
        ),
    },
    {
      path: "templates",
      name: "templates",
      component: () =>
        import(
          /* webpackChunkName: "templates" */ "@/modules/adminJoin/pages/Templates.vue"
        ),
    },
    {
      path: "masivos",
      name: "masivos",
      component: () =>
        import(
          /* webpackChunkName: "masivos" */ "@/modules/adminJoin/pages/Masivos.vue"
        ),
    },
    {
      path: "predefinidos",
      name: "predefinidos",
      component: () =>
        import(
          /* webpackChunkName: "predefinidos" */ "@/modules/adminJoin/pages/Predefinidos.vue"
        ),
    },
    {
      path: "secuencias",
      name: "secuencias",
      component: () =>
        import(
          /* webpackChunkName: "secuencias" */ "@/modules/adminJoin/pages/Secuencias.vue"
        ),
    },
  ],
}